export const patientConfig = {
  maturityAgeLimits: {
    baby: 2, // inclusive
    teen: 12, // inclusive
  },
};
